import { gql } from "@apollo/client";

export const updateSiteIncidentMutation = gql`
mutation($input: SiteIncidentInput!){
  updateSiteIncident(input: $input) {
    message
    response
  }
}
`;